export const ROLES = [
  'customer',
  'customer_admin',
  'support_agent',
  'developer',
  'qa_engineer',
  'team_lead',
  'system_admin',
] as const;
export type Role = (typeof ROLES)[number];

export const EXTERNAL_ROLES: readonly Role[] = ['customer', 'customer_admin'];
export const isInternalRole = (role: Role): boolean => !EXTERNAL_ROLES.includes(role);

/** Staff roles that only see their own queue: tickets assigned to them (and any they filed themselves). */
export const ASSIGNED_ONLY_ROLES: readonly Role[] = ['support_agent', 'developer'];

export const PRIORITIES = ['critical', 'high', 'medium', 'low'] as const;
export type Priority = (typeof PRIORITIES)[number];

export const SEVERITIES = ['blocker', 'critical', 'major', 'minor', 'cosmetic'] as const;
export type Severity = (typeof SEVERITIES)[number];

export const STATUSES = [
  'draft',
  'new',
  'assigned',
  'in_progress',
  'pending_customer',
  'ready_for_qa',
  'testing',
  'resolved',
  'closed',
  'reopened',
  'on_hold',
  'duplicate',
  'cancelled',
  'deferred',
  'escalated',
] as const;
export type TicketStatus = (typeof STATUSES)[number];

export const TERMINAL_STATUSES: readonly TicketStatus[] = ['closed', 'duplicate', 'cancelled'];

/** What customers see: 6 stages instead of the 15 internal statuses (shared by the UI and emails). */
export type CustomerStage = 'draft' | 'received' | 'in_progress' | 'waiting_on_you' | 'resolved' | 'closed';
export const CUSTOMER_STAGE: Readonly<Record<TicketStatus, CustomerStage>> = {
  draft: 'draft',
  new: 'received',
  assigned: 'received',
  in_progress: 'in_progress',
  ready_for_qa: 'in_progress',
  testing: 'in_progress',
  reopened: 'in_progress',
  on_hold: 'in_progress',
  escalated: 'in_progress',
  deferred: 'in_progress',
  pending_customer: 'waiting_on_you',
  resolved: 'resolved',
  closed: 'closed',
  duplicate: 'closed',
  cancelled: 'closed',
};

export interface SlaTargets {
  firstResponseMinutes: number;
  resolutionMinutes: number;
}
export type SlaPolicy = Record<Priority, SlaTargets>;
